import _styled from "styled-components";
type Props = {
  show: boolean;
};
export function DeepDiveGalleryOverlay(props: Props) {
  const {
    show
  } = props;
  if (!show) {
    return null;
  }
  return <_StyledDiv />;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "deep-dive-gallery-overlay___StyledDiv",
  componentId: "sc-1mek53m-0"
})({
  "pointerEvents": "none",
  "position": "absolute",
  "inset": "0",
  "zIndex": "10",
  "backgroundColor": "rgba(0, 7, 4, 0.6)"
});